import axiosInstance from '../../utils/axios';

/**
 * TypeScript interface corresponding to the DTO returned by the backend.
 * (Same definition as in your component for type safety.)
 */
export interface PaymentItemDTO {
  itemId: string;    // e.g. "CHALLENGE_50000"
  itemName: string;  // e.g. "50000K Challenge"
  price: number;     // unit price paid
  discount: number;  // per-unit discount (initialPrice – price)
  quantity: number;  // quantity purchased
}

export interface PaymentResponseDTO {
  transactionId: string;   // e.g. "admin_give_…"
  value: number;           // total sum
  currency: string;        // e.g. "EUR"
  affiliation: string | null;
  coupon: string | null;
  items: PaymentItemDTO[];
}

/**
 * Calls GET /shop/details/{paymentId} and returns the full DTO.
 */
export async function getOrderDetails(
  paymentId: string
): Promise<PaymentResponseDTO> {
  const response = await axiosInstance.get<PaymentResponseDTO>(
    `/shop/details/${paymentId}`
  );
  return response.data;
}
